// Supplier Management Data
export const suppliers = [
  {
    id: 'SUP001',
    name: '東亞電子科技有限公司',
    englishName: 'East Asia Electronics Technology Ltd.',
    code: 'EAET',
    type: 'manufacturer',
    category: 'electronics',
    status: 'active',
    rating: 4.5,
    establishedYear: 2015,
    registrationNumber: 'CR-2015-001234',
    taxNumber: 'TAX-HK-001234567',
    website: 'https://eastasiaelectronics.com',
    logo: 'https://images.unsplash.com/photo-1560472355-536de3962603?w=200&h=200&fit=crop',
    
    // Contact Information
    contacts: {
      primary: {
        name: '張志明',
        englishName: 'Vincent Zhang',
        position: '業務經理',
        phone: '+852 2234-5678',
        mobile: '+852 9876-5432',
        email: 'vincent.zhang@eastasiaelectronics.com',
        wechat: 'vincent_zhang_hk'
      },
      finance: {
        name: '李美玲',
        englishName: 'Mary Li',
        position: '財務主管',
        phone: '+852 2234-5679',
        email: 'mary.li@eastasiaelectronics.com'
      },
      quality: {
        name: '王建華',
        englishName: 'John Wang',
        position: '品質總監',
        phone: '+852 2234-5680',
        email: 'john.wang@eastasiaelectronics.com'
      }
    },
    
    // Address Information
    addresses: {
      headquarters: {
        type: 'headquarters',
        address: '香港九龍觀塘工業區創業街15號',
        englishAddress: '15 Entrepreneurship Street, Kwun Tong Industrial Area, Kowloon, Hong Kong',
        postalCode: '000000',
        city: '香港',
        country: 'Hong Kong'
      },
      factory: {
        type: 'factory',
        address: '廣東省深圳市寶安區西鄉街道固戍工業區',
        englishAddress: 'Gushu Industrial Zone, Xixiang Street, Baoan District, Shenzhen, Guangdong',
        postalCode: '518100',
        city: '深圳',
        country: 'China'
      },
      warehouse: {
        type: 'warehouse',
        address: '香港新界葵涌貨櫃碼頭路88號',
        englishAddress: '88 Container Port Road, Kwai Chung, New Territories, Hong Kong',
        postalCode: '000000',
        city: '香港',
        country: 'Hong Kong'
      }
    },
    
    // Financial Information
    financial: {
      currency: 'HKD',
      creditLimit: 500000,
      paymentTerms: 'NET30',
      paymentMethod: 'bank_transfer',
      bankInfo: {
        bankName: '恒生銀行',
        accountNumber: '024-123456-001',
        swiftCode: 'HASEHKHH'
      },
      annualRevenue: 25000000,
      employees: 150
    },
    
    // Capabilities
    capabilities: {
      products: ['電子元件', '半導體', '電路板', '連接器', '傳感器'],
      services: ['設計', '製造', '測試', '包裝', '物流'],
      certifications: ['ISO9001', 'ISO14001', 'OHSAS18001', 'RoHS', 'CE'],
      productionCapacity: '月產能100萬件',
      leadTime: '7-14天',
      moq: 1000,
      customization: true
    },
    
    // Performance Metrics
    performance: {
      qualityScore: 4.5,
      deliveryScore: 4.2,
      serviceScore: 4.3,
      priceScore: 4.1,
      overallScore: 4.3,
      onTimeDeliveryRate: 92,
      qualityPassRate: 98,
      responseTime: '2小時內',
      defectRate: 0.02
    },
    
    // Historical Data
    history: {
      firstOrder: '2020-03-15',
      totalOrders: 156,
      totalValue: 8750000,
      averageOrderValue: 56089,
      lastOrderDate: '2024-01-15',
      relationshipDuration: '4年2個月'
    }
  },
  
  {
    id: 'SUP002',
    name: '華南機械製造有限公司',
    englishName: 'South China Machinery Manufacturing Ltd.',
    code: 'SCMM',
    type: 'manufacturer',
    category: 'machinery',
    status: 'active',
    rating: 4.2,
    establishedYear: 2010,
    registrationNumber: 'CR-2010-005678',
    taxNumber: 'TAX-HK-005678901',
    website: 'https://southchinamachinery.com',
    logo: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=200&h=200&fit=crop',
    
    contacts: {
      primary: {
        name: '陳志強',
        englishName: 'Tony Chen',
        position: '銷售總監',
        phone: '+852 2345-6789',
        mobile: '+852 9123-4567',
        email: 'tony.chen@southchinamachinery.com',
        wechat: 'tony_chen_scm'
      },
      technical: {
        name: '劉工程師',
        englishName: 'Engineer Liu',
        position: '技術總監',
        phone: '+852 2345-6790',
        email: 'engineer.liu@southchinamachinery.com'
      }
    },
    
    addresses: {
      headquarters: {
        type: 'headquarters',
        address: '香港新界屯門工業區青山道200號',
        englishAddress: '200 Castle Peak Road, Tuen Mun Industrial Area, New Territories, Hong Kong',
        postalCode: '000000',
        city: '香港',
        country: 'Hong Kong'
      },
      factory: {
        type: 'factory',
        address: '廣東省東莞市長安鎮烏沙工業區',
        englishAddress: 'Wusha Industrial Zone, Changan Town, Dongguan, Guangdong',
        postalCode: '523850',
        city: '東莞',
        country: 'China'
      }
    },
    
    financial: {
      currency: 'HKD',
      creditLimit: 800000,
      paymentTerms: 'NET45',
      paymentMethod: 'bank_transfer',
      bankInfo: {
        bankName: '中國銀行',
        accountNumber: '012-789456-123',
        swiftCode: 'BKCHHKHH'
      },
      annualRevenue: 45000000,
      employees: 280
    },
    
    capabilities: {
      products: ['精密機械', '自動化設備', '模具', '治具', '機械零件'],
      services: ['設計', '製造', '安裝', '維修', '技術支援'],
      certifications: ['ISO9001', 'ISO14001', 'CE', 'UL'],
      productionCapacity: '月產能500台',
      leadTime: '14-21天',
      moq: 1,
      customization: true
    },
    
    performance: {
      qualityScore: 4.3,
      deliveryScore: 4.0,
      serviceScore: 4.2,
      priceScore: 4.4,
      overallScore: 4.2,
      onTimeDeliveryRate: 88,
      qualityPassRate: 96,
      responseTime: '4小時內',
      defectRate: 0.04
    },
    
    history: {
      firstOrder: '2019-08-20',
      totalOrders: 89,
      totalValue: 12500000,
      averageOrderValue: 140449,
      lastOrderDate: '2024-01-10',
      relationshipDuration: '4年5個月'
    }
  },
  
  {
    id: 'SUP003',
    name: '環球物流供應鏈有限公司',
    englishName: 'Global Logistics Supply Chain Ltd.',
    code: 'GLSC',
    type: 'distributor',
    category: 'logistics',
    status: 'active',
    rating: 4.7,
    establishedYear: 2018,
    registrationNumber: 'CR-2018-009876',
    taxNumber: 'TAX-HK-009876543',
    website: 'https://globallogistics.hk',
    logo: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=200&h=200&fit=crop',
    
    contacts: {
      primary: {
        name: '黃經理',
        englishName: 'Manager Wong',
        position: '客戶服務經理',
        phone: '+852 2456-7890',
        mobile: '+852 9234-5678',
        email: 'manager.wong@globallogistics.hk',
        wechat: 'manager_wong_gl'
      },
      operations: {
        name: '林主管',
        englishName: 'Supervisor Lam',
        position: '營運主管',
        phone: '+852 2456-7891',
        email: 'supervisor.lam@globallogistics.hk'
      }
    },
    
    addresses: {
      headquarters: {
        type: 'headquarters',
        address: '香港九龍長沙灣道833號',
        englishAddress: '833 Cheung Sha Wan Road, Kowloon, Hong Kong',
        postalCode: '000000',
        city: '香港',
        country: 'Hong Kong'
      },
      warehouse: {
        type: 'warehouse',
        address: '香港新界青衣島長青路1號',
        englishAddress: '1 Evergreen Road, Tsing Yi Island, New Territories, Hong Kong',
        postalCode: '000000',
        city: '香港',
        country: 'Hong Kong'
      }
    },
    
    financial: {
      currency: 'HKD',
      creditLimit: 300000,
      paymentTerms: 'NET15',
      paymentMethod: 'bank_transfer',
      bankInfo: {
        bankName: '匯豐銀行',
        accountNumber: '004-567890-838',
        swiftCode: 'HSBCHKHH'
      },
      annualRevenue: 15000000,
      employees: 85
    },
    
    capabilities: {
      products: ['包裝材料', '物流設備', '倉儲用品', '運輸工具', '標籤耗材'],
      services: ['倉儲', '運輸', '包裝', '配送', '供應鏈管理'],
      certifications: ['ISO9001', 'ISO14001', 'TAPA', 'C-TPAT'],
      productionCapacity: '日處理能力10000件',
      leadTime: '1-3天',
      moq: 100,
      customization: false
    },
    
    performance: {
      qualityScore: 4.6,
      deliveryScore: 4.8,
      serviceScore: 4.7,
      priceScore: 4.5,
      overallScore: 4.7,
      onTimeDeliveryRate: 98,
      qualityPassRate: 99,
      responseTime: '1小時內',
      defectRate: 0.01
    },
    
    history: {
      firstOrder: '2021-01-10',
      totalOrders: 234,
      totalValue: 3200000,
      averageOrderValue: 13675,
      lastOrderDate: '2024-01-18',
      relationshipDuration: '3年1個月'
    }
  },
  
  {
    id: 'SUP004',
    name: '新科技材料有限公司',
    englishName: 'New Technology Materials Ltd.',
    code: 'NTML',
    type: 'manufacturer',
    category: 'materials',
    status: 'pending',
    rating: 0,
    establishedYear: 2022,
    registrationNumber: 'CR-2022-012345',
    taxNumber: 'TAX-HK-012345678',
    website: 'https://newtechmaterials.com',
    logo: 'https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=200&h=200&fit=crop',
    
    contacts: {
      primary: {
        name: '趙總經理',
        englishName: 'General Manager Zhao',
        position: '總經理',
        phone: '+852 2567-8901',
        mobile: '+852 9345-6789',
        email: 'gm.zhao@newtechmaterials.com',
        wechat: 'gm_zhao_ntm'
      }
    },
    
    addresses: {
      headquarters: {
        type: 'headquarters',
        address: '香港新界沙田科學園科技大道西19號',
        englishAddress: '19 Science Park West Avenue, Sha Tin, New Territories, Hong Kong',
        postalCode: '000000',
        city: '香港',
        country: 'Hong Kong'
      }
    },
    
    financial: {
      currency: 'HKD',
      creditLimit: 0,
      paymentTerms: 'COD',
      paymentMethod: 'cash',
      bankInfo: {
        bankName: '渣打銀行',
        accountNumber: '001-234567-890',
        swiftCode: 'SCBLHKHH'
      },
      annualRevenue: 5000000,
      employees: 25
    },
    
    capabilities: {
      products: ['複合材料', '特殊合金', '陶瓷材料', '高分子材料', '納米材料'],
      services: ['材料開發', '測試', '技術諮詢', '客製化', '樣品製作'],
      certifications: ['ISO9001', 'RoHS'],
      productionCapacity: '月產能50噸',
      leadTime: '21-30天',
      moq: 10,
      customization: true
    },
    
    performance: {
      qualityScore: 0,
      deliveryScore: 0,
      serviceScore: 0,
      priceScore: 0,
      overallScore: 0,
      onTimeDeliveryRate: 0,
      qualityPassRate: 0,
      responseTime: '待評估',
      defectRate: 0
    },
    
    history: {
      firstOrder: null,
      totalOrders: 0,
      totalValue: 0,
      averageOrderValue: 0,
      lastOrderDate: null,
      relationshipDuration: '新供應商'
    }
  },
  
  {
    id: 'SUP005',
    name: '永達包裝印刷有限公司',
    englishName: 'Wing Tat Packaging & Printing Ltd.',
    code: 'WTPP',
    type: 'manufacturer',
    category: 'packaging',
    status: 'suspended',
    rating: 2.8,
    establishedYear: 2005,
    registrationNumber: 'CR-2005-567890',
    taxNumber: 'TAX-HK-567890123',
    website: 'https://wingtatpackaging.com',
    logo: 'https://images.unsplash.com/photo-1566576912321-d58ddd7a6088?w=200&h=200&fit=crop',
    
    contacts: {
      primary: {
        name: '吳先生',
        englishName: 'Mr. Wu',
        position: '業務代表',
        phone: '+852 2678-9012',
        mobile: '+852 9456-7890',
        email: 'mr.wu@wingtatpackaging.com',
        wechat: 'mr_wu_wtpp'
      }
    },
    
    addresses: {
      headquarters: {
        type: 'headquarters',
        address: '香港新界元朗工業邨宏業西街15號',
        englishAddress: '15 Hung Yip West Street, Yuen Long Industrial Estate, New Territories, Hong Kong',
        postalCode: '000000',
        city: '香港',
        country: 'Hong Kong'
      }
    },
    
    financial: {
      currency: 'HKD',
      creditLimit: 100000,
      paymentTerms: 'NET15',
      paymentMethod: 'bank_transfer',
      bankInfo: {
        bankName: '東亞銀行',
        accountNumber: '015-678901-234',
        swiftCode: 'BEASHKHH'
      },
      annualRevenue: 8000000,
      employees: 45
    },
    
    capabilities: {
      products: ['紙箱', '包裝盒', '標籤', '說明書', '包裝材料'],
      services: ['設計', '印刷', '包裝', '物流', '倉儲'],
      certifications: ['ISO9001', 'FSC'],
      productionCapacity: '月產能100萬件',
      leadTime: '7-10天',
      moq: 5000,
      customization: true
    },
    
    performance: {
      qualityScore: 2.5,
      deliveryScore: 3.0,
      serviceScore: 2.8,
      priceScore: 3.5,
      overallScore: 2.8,
      onTimeDeliveryRate: 75,
      qualityPassRate: 85,
      responseTime: '24小時內',
      defectRate: 0.15
    },
    
    history: {
      firstOrder: '2018-05-15',
      totalOrders: 45,
      totalValue: 650000,
      averageOrderValue: 14444,
      lastOrderDate: '2023-08-20',
      relationshipDuration: '5年8個月'
    }
  }
];

// Supplier Evaluation Criteria
export const evaluationCriteria = [
  {
    id: 'quality',
    name: '品質管理',
    weight: 30,
    description: '產品品質、品質系統、認證等',
    subcriteria: [
      { id: 'quality_system', name: '品質系統', weight: 40 },
      { id: 'certifications', name: '認證證書', weight: 30 },
      { id: 'defect_rate', name: '缺陷率', weight: 30 }
    ]
  },
  {
    id: 'delivery',
    name: '交期管理',
    weight: 25,
    description: '準時交貨、交期承諾、應變能力',
    subcriteria: [
      { id: 'on_time_delivery', name: '準時交貨率', weight: 50 },
      { id: 'lead_time', name: '交期承諾', weight: 30 },
      { id: 'flexibility', name: '應變能力', weight: 20 }
    ]
  },
  {
    id: 'service',
    name: '服務品質',
    weight: 20,
    description: '客戶服務、技術支援、溝通效率',
    subcriteria: [
      { id: 'customer_service', name: '客戶服務', weight: 40 },
      { id: 'technical_support', name: '技術支援', weight: 35 },
      { id: 'communication', name: '溝通效率', weight: 25 }
    ]
  },
  {
    id: 'price',
    name: '價格競爭力',
    weight: 15,
    description: '價格水準、付款條件、成本效益',
    subcriteria: [
      { id: 'price_level', name: '價格水準', weight: 50 },
      { id: 'payment_terms', name: '付款條件', weight: 30 },
      { id: 'cost_effectiveness', name: '成本效益', weight: 20 }
    ]
  },
  {
    id: 'financial',
    name: '財務穩定性',
    weight: 10,
    description: '財務狀況、經營穩定性、信用記錄',
    subcriteria: [
      { id: 'financial_health', name: '財務健康', weight: 50 },
      { id: 'business_stability', name: '經營穩定', weight: 30 },
      { id: 'credit_record', name: '信用記錄', weight: 20 }
    ]
  }
];

// Supplier Evaluation Records
export const supplierEvaluations = [
  {
    id: 'EVAL001',
    supplierId: 'SUP001',
    evaluationDate: '2024-01-15',
    evaluator: '採購部 - 張經理',
    period: '2023Q4',
    status: 'completed',
    
    scores: {
      quality: {
        score: 4.5,
        weight: 30,
        weightedScore: 1.35,
        subcriteria: {
          quality_system: 4.8,
          certifications: 4.5,
          defect_rate: 4.2
        },
        comments: '品質系統完善，認證齊全，缺陷率控制良好'
      },
      delivery: {
        score: 4.2,
        weight: 25,
        weightedScore: 1.05,
        subcriteria: {
          on_time_delivery: 4.6,
          lead_time: 4.0,
          flexibility: 3.8
        },
        comments: '準時交貨表現優秀，但應變能力有待提升'
      },
      service: {
        score: 4.3,
        weight: 20,
        weightedScore: 0.86,
        subcriteria: {
          customer_service: 4.5,
          technical_support: 4.2,
          communication: 4.2
        },
        comments: '服務態度良好，技術支援及時'
      },
      price: {
        score: 4.1,
        weight: 15,
        weightedScore: 0.615,
        subcriteria: {
          price_level: 4.0,
          payment_terms: 4.2,
          cost_effectiveness: 4.1
        },
        comments: '價格合理，付款條件可接受'
      },
      financial: {
        score: 4.4,
        weight: 10,
        weightedScore: 0.44,
        subcriteria: {
          financial_health: 4.5,
          business_stability: 4.3,
          credit_record: 4.4
        },
        comments: '財務狀況穩健，經營狀況良好'
      }
    },
    
    totalScore: 4.285,
    grade: 'A',
    recommendation: 'continue',
    
    strengths: [
      '品質管理系統完善',
      '準時交貨率高',
      '客戶服務優秀',
      '財務狀況穩定'
    ],
    
    improvements: [
      '提升緊急訂單應變能力',
      '優化交期承諾準確性',
      '加強技術創新能力'
    ],
    
    actionItems: [
      {
        item: '與供應商討論緊急訂單處理流程',
        responsible: '採購部',
        dueDate: '2024-02-15',
        status: 'pending'
      },
      {
        item: '建立定期技術交流機制',
        responsible: '技術部',
        dueDate: '2024-03-01',
        status: 'pending'
      }
    ]
  },
  
  {
    id: 'EVAL002',
    supplierId: 'SUP002',
    evaluationDate: '2024-01-12',
    evaluator: '採購部 - 李經理',
    period: '2023Q4',
    status: 'completed',
    
    scores: {
      quality: {
        score: 4.3,
        weight: 30,
        weightedScore: 1.29,
        subcriteria: {
          quality_system: 4.2,
          certifications: 4.5,
          defect_rate: 4.2
        },
        comments: '品質穩定，認證完整'
      },
      delivery: {
        score: 4.0,
        weight: 25,
        weightedScore: 1.0,
        subcriteria: {
          on_time_delivery: 4.4,
          lead_time: 3.8,
          flexibility: 3.8
        },
        comments: '交期管理需要改善'
      },
      service: {
        score: 4.2,
        weight: 20,
        weightedScore: 0.84,
        subcriteria: {
          customer_service: 4.0,
          technical_support: 4.5,
          communication: 4.0
        },
        comments: '技術支援能力強'
      },
      price: {
        score: 4.4,
        weight: 15,
        weightedScore: 0.66,
        subcriteria: {
          price_level: 4.5,
          payment_terms: 4.2,
          cost_effectiveness: 4.5
        },
        comments: '價格競爭力強'
      },
      financial: {
        score: 4.1,
        weight: 10,
        weightedScore: 0.41,
        subcriteria: {
          financial_health: 4.2,
          business_stability: 4.0,
          credit_record: 4.1
        },
        comments: '財務狀況良好'
      }
    },
    
    totalScore: 4.2,
    grade: 'A',
    recommendation: 'continue',
    
    strengths: [
      '價格競爭力強',
      '技術支援能力優秀',
      '產品品質穩定'
    ],
    
    improvements: [
      '改善交期管理',
      '提升客戶服務水準',
      '加強溝通效率'
    ],
    
    actionItems: [
      {
        item: '建立交期監控機制',
        responsible: '採購部',
        dueDate: '2024-02-28',
        status: 'in_progress'
      }
    ]
  }
];

// Supplier Quotations
export const supplierQuotations = [
  {
    id: 'QUO001',
    requestId: 'RFQ001',
    supplierId: 'SUP001',
    quotationNumber: 'Q2024-001',
    quotationDate: '2024-01-20',
    validUntil: '2024-02-20',
    status: 'submitted',
    currency: 'HKD',
    
    contactPerson: {
      name: '張志明',
      position: '業務經理',
      phone: '+852 2234-5678',
      email: 'vincent.zhang@eastasiaelectronics.com'
    },
    
    items: [
      {
        id: 1,
        productCode: 'ELE-001',
        productName: '電阻器 1K歐姆',
        specification: '1/4W, 5%, 碳膜電阻',
        quantity: 10000,
        unitPrice: 0.15,
        totalPrice: 1500,
        leadTime: '7天',
        moq: 1000,
        packaging: '每包1000個'
      },
      {
        id: 2,
        productCode: 'ELE-002',
        productName: '電容器 100μF',
        specification: '25V, 鋁質電解電容',
        quantity: 5000,
        unitPrice: 0.85,
        totalPrice: 4250,
        leadTime: '10天',
        moq: 500,
        packaging: '每包500個'
      }
    ],
    
    subtotal: 5750,
    discount: 0,
    discountAmount: 0,
    shippingCost: 200,
    tax: 0,
    totalAmount: 5950,
    
    terms: {
      payment: 'NET30',
      delivery: 'FOB Hong Kong',
      warranty: '12個月',
      validity: '30天'
    },
    
    notes: '數量達到20000個以上可享5%折扣',
    
    attachments: [
      {
        name: '產品規格書.pdf',
        url: '/documents/product-spec-001.pdf',
        size: '2.5MB'
      }
    ]
  },
  
  {
    id: 'QUO002',
    requestId: 'RFQ001',
    supplierId: 'SUP002',
    quotationNumber: 'Q2024-002',
    quotationDate: '2024-01-22',
    validUntil: '2024-02-22',
    status: 'submitted',
    currency: 'HKD',
    
    contactPerson: {
      name: '陳志強',
      position: '銷售總監',
      phone: '+852 2345-6789',
      email: 'tony.chen@southchinamachinery.com'
    },
    
    items: [
      {
        id: 1,
        productCode: 'ELE-001',
        productName: '電阻器 1K歐姆',
        specification: '1/4W, 5%, 碳膜電阻',
        quantity: 10000,
        unitPrice: 0.18,
        totalPrice: 1800,
        leadTime: '10天',
        moq: 2000,
        packaging: '每包2000個'
      },
      {
        id: 2,
        productCode: 'ELE-002',
        productName: '電容器 100μF',
        specification: '25V, 鋁質電解電容',
        quantity: 5000,
        unitPrice: 0.90,
        totalPrice: 4500,
        leadTime: '12天',
        moq: 1000,
        packaging: '每包1000個'
      }
    ],
    
    subtotal: 6300,
    discount: 3,
    discountAmount: 189,
    shippingCost: 150,
    tax: 0,
    totalAmount: 6261,
    
    terms: {
      payment: 'NET45',
      delivery: 'FOB Hong Kong',
      warranty: '18個月',
      validity: '45天'
    },
    
    notes: '首次合作享3%折扣，後續訂單可協商更優惠價格',
    
    attachments: [
      {
        name: '報價明細.xlsx',
        url: '/documents/quotation-detail-002.xlsx',
        size: '1.2MB'
      }
    ]
  }
];

// RFQ (Request for Quotation) Data
export const rfqData = [
  {
    id: 'RFQ001',
    rfqNumber: 'RFQ-2024-001',
    title: '電子元件採購',
    description: '生產線所需電子元件採購',
    requestDate: '2024-01-18',
    responseDeadline: '2024-01-25',
    status: 'active',
    requestor: '生產部 - 王經理',
    
    items: [
      {
        id: 1,
        productCode: 'ELE-001',
        productName: '電阻器 1K歐姆',
        specification: '1/4W, 5%, 碳膜電阻',
        quantity: 10000,
        targetPrice: 0.12,
        requiredDate: '2024-02-15'
      },
      {
        id: 2,
        productCode: 'ELE-002',
        productName: '電容器 100μF',
        specification: '25V, 鋁質電解電容',
        quantity: 5000,
        targetPrice: 0.80,
        requiredDate: '2024-02-20'
      }
    ],
    
    requirements: [
      '符合RoHS標準',
      '提供品質證明文件',
      '包裝需防靜電處理',
      '交貨地點：香港觀塘工業區'
    ],
    
    invitedSuppliers: ['SUP001', 'SUP002', 'SUP003'],
    receivedQuotations: ['QUO001', 'QUO002'],
    
    evaluationCriteria: [
      { criterion: '價格', weight: 40 },
      { criterion: '品質', weight: 30 },
      { criterion: '交期', weight: 20 },
      { criterion: '服務', weight: 10 }
    ]
  }
];

// Supplier Performance Dashboard Data
export const supplierPerformanceDashboard = {
  summary: {
    totalSuppliers: 5,
    activeSuppliers: 3,
    pendingSuppliers: 1,
    suspendedSuppliers: 1,
    averageRating: 4.2,
    totalSpend: 24100000,
    costSavings: 2050000,
    onTimeDeliveryRate: 92.5
  },
  
  topSuppliers: [
    { supplierId: 'SUP003', name: '環球物流供應鏈', rating: 4.7, spend: 3200000 },
    { supplierId: 'SUP001', name: '東亞電子科技', rating: 4.5, spend: 8750000 },
    { supplierId: 'SUP002', name: '華南機械製造', rating: 4.2, spend: 12500000 }
  ],
  
  riskSuppliers: [
    { supplierId: 'SUP005', name: '永達包裝印刷', rating: 2.8, riskLevel: 'high', issues: ['品質問題', '交期延遲'] },
    { supplierId: 'SUP004', name: '新科技材料', rating: 0, riskLevel: 'medium', issues: ['新供應商', '未評估'] }
  ],
  
  categorySpend: [
    { category: 'electronics', spend: 8750000, percentage: 36.3 },
    { category: 'machinery', spend: 12500000, percentage: 51.9 },
    { category: 'logistics', spend: 3200000, percentage: 13.3 },
    { category: 'materials', spend: 0, percentage: 0 },
    { category: 'packaging', spend: 650000, percentage: 2.7 }
  ],
  
  monthlyTrends: [
    { month: '2023-08', totalSpend: 1800000, suppliers: 4, onTimeRate: 88 },
    { month: '2023-09', totalSpend: 2100000, suppliers: 4, onTimeRate: 90 },
    { month: '2023-10', totalSpend: 2300000, suppliers: 4, onTimeRate: 91 },
    { month: '2023-11', totalSpend: 2000000, suppliers: 4, onTimeRate: 93 },
    { month: '2023-12', totalSpend: 2400000, suppliers: 4, onTimeRate: 94 },
    { month: '2024-01', totalSpend: 2200000, suppliers: 5, onTimeRate: 95 }
  ]
};

export default {
  suppliers,
  evaluationCriteria,
  supplierEvaluations,
  supplierQuotations,
  rfqData,
  supplierPerformanceDashboard
}; 